import styles from './desktop.module.scss';
import { VNode, h } from 'vue';
import { Page } from '../../components/page';
import { Figure } from './figure';

export function Desktop(light: boolean, slot: () => VNode) {
    return h(Page, { light, class: styles.desktop }, {
        default: slot,
        aside: () => Figure(),
    });
}
